// Example: src/components/filter/CategoryFilter.jsx

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../redux/actions/filterActions";

const TypesFilter = () => {
  const dispatch = useDispatch();
  const {
    loading: optionsLoading,
    data: filterOptions = {},
    error: optionsError,
  } = useSelector((state) => state.filterOptions) || {};
  const chosenFilters = useSelector((state) => state.filters) || {};
  const types = filterOptions?.product_types;

  const handleSelect = (type) => {
    const updated = chosenFilters.types?.includes(type)
      ? chosenFilters.types.filter((t) => t !== type)
      : [...chosenFilters.types, type];

    dispatch(setFilter("types", updated));
  };

  if (optionsError) return <p>Error loading filters: {optionsError}</p>;
  if (optionsLoading) return <p>Loading filters…</p>;

  return (
    <div className="my-4">
      <h6 className="font-semibold lg:text-lg mb-2">Types</h6>
      <div className="flex gap-2 items-center flex-wrap">
        {types?.map((type) => (
          <span
            key={type.id}
            onClick={() => handleSelect(type.product_type)}
            className={`cursor-pointer p-2 rounded-md border ${
              chosenFilters.types?.includes(type.product_type)
                ? "bg-medium-theme-color text-white border-0"
                : "bg-white text-black "
            }`}
          >
            {type.product_type}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TypesFilter;
